import { SupplierMappingTypeEnum } from '@gtpl/shared-models/common-models';
import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, Index } from "typeorm";

@Entity('supplier_creation')
export class SupplierCreation {


  @PrimaryGeneratedColumn("increment", { name: 'id' })
  id: number;

  @Column("enum", {
    nullable: true,
    name: "supplier_type",
    enum: SupplierMappingTypeEnum
  })
  // @Index({unique:true})
  supplierType: SupplierMappingTypeEnum;
  @Column("int", {
    nullable: true,
    name: "supplier_id"
  })
  supplierId: number;
  @Column("varchar", {
    nullable: true,
    length: 40,
    name: "user_name"
  })
  @Index({ unique: true })
  userName: string;
  @Column("varchar", {
    nullable: true,
    length: 250,
    name: "password"
  })
  // @Index({unique:true})
  password: string;
  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @Column("int", {
    nullable: true,
    name: "border_radius"
  })
  borderRadius: number;

  @Column("varchar", {
    nullable: true,
    name: "primary_color"
  })
  primaryColor: string;
  @Column("boolean", {
    default: true,
    name: "is_darkmode"
  })
  isDarkMode: boolean;

  @Column("mediumblob", {
    nullable: true,
    name: "file"
})
file: Buffer;

@Column('varchar', {
    nullable: true,
    length: 600,
    name: 'file_path'
})
filePath: string;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
}
